<template>
    <div id="index">
        <my-header></my-header>
        <div class="bigSwiper">
            <div >
                <div class="slide1" >
                    <img class="bg1" src="../assets/images/index/bg.jpg"/>
                    <img class="text" src="../assets/images/index/text1.png"/>
                </div>
                <div class="slide2" >
                    <section >
                        <!--<p>招标：1234</p>-->
                        <h3 class="title_1">
                            <img src="../assets/images/index/tit01.png"/>
                            <span @click="toInviteList" class="view">查看更多&gt;&gt;</span>
                        </h3>
                        <el-row v-if="lstTenderBidMessageResponseVO.length">
                            <el-col :span="12" v-for="(item,i) in lstTenderBidMessageResponseVO" :key="i">
                                <div class="left">
                                    <img :src='"../assets/images/index/0"+(i+1)+".png"'>
                                </div>
                                <div class="right">
                                    <div>
                                        <h4 class="overflowH" @click="$router.push('/invite/listDetail/'+item.id)">{{item.msgTitle}}</h4>
                                        <strong v-if="item.deadlineTime">
                                            <span>{{ item.deadlineTime.split(' ')[0] }}</span>
                                            结束报名
                                        </strong>
                                    </div>
                                    <p v-if="item.msgContent">简介：{{ item.msgContent }}</p>
                                </div>
                            </el-col>
                        </el-row>
                        <p v-else class="none">------ 暂无招标公告 ------</p>
                    </section>
                </div>


                <div class="slide2" >
                    <section >
                        <h3 class="title_1">
                            <img src="../assets/images/index/tit04.png"/>
                            <span @click="toWinList" class="view">查看更多&gt;&gt;</span>
                        </h3>
                        <el-row v-if="lstWinBidMessageResponseVO.length">
                            <el-col :span="12" v-for="(item,i) in lstWinBidMessageResponseVO" :key="i">
                                <div class="left">
                                    <img :src='"../assets/images/index/0"+(i+1)+".png"'>
                                </div>
                                <div class="right">
                                    <div>
                                        <h4 class="overflowH">{{ item.msgTitle }}</h4>
                                    </div>
                                    <p v-if="item.bidTime">{{ item.bidTime.split(' ')[0] }}</p>
                                </div>
                            </el-col>
                        </el-row>
                        <p v-else class="none">------ 暂无中标公告 ------</p>
                    </section>
                </div>
               
                <!-- <div class="slide3" >
                    <section >
                        <h3 class="title_1">
                            <img src="../assets/images/index/tit04.png"/>
                            <span @click="toWinList" class="view">查看更多&gt;&gt;</span>
                        </h3>
                        <el-row v-if="lstWinBidMessageResponseVO.length">
                            <el-col :span="12"  v-for="(item,i) in lstWinBidMessageResponseVO" :key="i">
                                <div class="left">
                                    <img :src='"../assets/images/index/0"+(i+1)+".png"'>
                                </div>
                                <div class="right">
                                    <div>
                                        <h4 class="overflowH">{{ item.msgTitle }}</h4>
                                    </div>
                                    <p v-if="item.bidTime">{{ item.bidTime.split(' ')[0] }}</p>
                                </div>
                            </el-col>
                        </el-row>
                        <p v-else class="none">------ 暂无中标公告 ------</p>
                    </section>
                </div> -->
                <div class="slide4">
                    <div class="main-container" v-if="lstStrategicPartnersResponseVO.length">
                        <img src="../assets/images/index/tit03.png"/>
                        <div class="swiper-container" v-if="lstStrategicPartnersResponseVO.length">
                            <el-carousel trigger="click" height="340px" >
                                <el-carousel-item v-for="(item,i) in lstStrategicPartnersResponseVO" :key="i">
                                    <ul class="partnersList">
                                        <li v-for="(val,inx) in item" :key="inx">
                                            <img style="width:90%;height:126px;" :src="val.attachmentVo.imgUrl" :title="val.partnerName"/>
                                        </li>
                                    </ul>
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                        <p v-else class="none">------ 暂无战略合作伙伴 ------</p>
                    </div>
                    <my-footer></my-footer>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/babel">
    import MyHeader from './common/Header'
    import MyFooter from './common/Footer'
    import Swiper from 'swiper'
    import util from '../util/index'
    export default {
        name: 'index',
        data(){
            return {
                hashVal: '',
                lstTenderBidMessageResponseVO: [],//招标公告
                lstWinBidMessageResponseVO: [],//中标公告
                lstStrategicPartnersResponseVO: [],//战略合作伙伴
            }
        },
        components: {
            MyHeader,
            MyFooter
        },
        created(){
            window.ellen = this;
           this.getData();
        },
        mounted(){
            var loginRightEl = document.getElementsByClassName('loginRight');
            if(loginRightEl.length){
                loginRightEl[0].className = 'loginRight loginIndex'
            }
        },
        methods: {
            getData(){
                let _this = this;
                this.$root.getHttp('v1/login/public/getRestIndex',function(res){
                    _this.lstTenderBidMessageResponseVO = res.data.data.lstTenderBidMessageResponseVO || [];
                    _this.lstWinBidMessageResponseVO = res.data.data.lstWinBidMessageResponseVO || [];
                    _this.lstStrategicPartnersResponseVO = res.data.data.lstStrategicPartnersResponseVOs || [];
                    if(_this.lstStrategicPartnersResponseVO.length){
                        _this.lstStrategicPartnersResponseVO.forEach((item,index)=>{
                            item.forEach( (val,inx) => {
                                if(val.attachmentVo){
                                    val.attachmentVo['imgUrl'] = util.baseUrl+'/v1/public/file/download?filePath='+val.attachmentVo.attachPath+'&oldFileName='+encodeURIComponent(val.attachmentVo.attachName);
                                }
                            })
                        });
                    }
                })
            },
            toInviteList(){//招标公告
                this.$root.activeIndex = 'invite';
                this.$router.push( '/invite-list');
            },
            toWinList(){//中标公告
                this.$root.activeIndex = 'win';
                this.$router.push('/win-list');
            }
        }
    }
</script>
<style scoped lang="scss">
    @import "../assets/_var.scss";
    @import "../assets/swiper.min.css";
    .swiper-container {
        padding: 0 42px;
        width: 1100px;
        height: 380px;
        margin-left: auto;
        margin-right: auto;
    }

    .slide1{
        position: relative;
        height: 40vh;
        .bg1 {
            display: block;
            width: 100%;
            min-width: 1300px;
            height: 100%;
        }
    }
    .text {
        width: 40%;
        height: auto;
        position: absolute;
        left: 50%;
        top: 27.5%;
        transform: translateX(-50%);
    }
    .slide2 {
      /*  background: url('../assets/images/index/bg2.jpg') no-repeat;
        background-size: 100% 100%;*/
    }
    .slide2 section{
        margin: 20px auto;
        box-sizing: border-box;
        padding: 20px;
        width: 1150px;
        height: 414px;
        background: rgba(255,255,255,1);
        /*box-shadow: 0 0 25px rgba(0,0,0,.3);*/
        .el-row {
            cursor: pointer;
        }
        .overflowH {
            max-width: 300px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .title_1{
        margin: 10px 0 20px;
        overflow: hidden;
    }
    .title_1 img {
        float: left;
        width: 304px;
        height: 26px;
    }
    .title_1 span {
        float: right;
        font-weight: normal;
        color: $--text-color-light;
    }
    .slide2 .el-col {
        height: 75px;
    }
    .slide2 .left {
        float: left;
        padding: 20px;
        background: $--secondary-fill-color;
        text-align: center;
        & img {
            width: 35px;
            height: auto;
        }
    }
    .slide2 .right {
        float: left;
        width: 85%;
        box-sizing: border-box;
        padding-left: 10px;
        & div{
            overflow: hidden;
            & h4 {
                margin: 0;
                line-height: 30px;
                float: left;
                font-size: 14px;
            }
            & h4:hover {
                color: $--primary-color;
                text-decoration: underline;
            }
            & strong {
                float: right;
                font-weight: normal;
                font-size: 12px;
                line-height: 30px;
                color: $--text-color-lighter;
            }
        }
        & p {
            margin: 0;
            text-align: left;
            font-size: 12px;
            color: $--text-color-lighter;
        }
    }

    .slide3 {
        position: relative;
        // height: 100vh;
        // min-height: 600px;
        box-sizing: border-box;
        padding: 40px 0;
        background: url('../assets/images/index/bg3.jpg') no-repeat 0 0/100% 100%;
        & section{
            position: relative;
            margin: 0px auto;
            box-sizing: border-box;
            padding: 30px 50px;
            width: 1150px;
            height: 414px;
            background: rgba(255,255,255,.85);
            box-shadow: 0 0 15px rgba(0,0,0,.2);
            .el-row {
                cursor: pointer;
            }
            .overflowH {
                max-width: 300px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .title_1{
                margin: 10px 0 20px;
                overflow: hidden;
            }
            .title_1 img {
                float: left;
                width: 340px;
                height: 26px;
            }
            .title_1 span {
                float: right;
                font-weight: normal;
                color: $--text-color-light;
            }
            .el-col {
                height: 75px;
            }
            .left {
                float: left;
                padding: 20px;
                background: $--secondary-fill-color;
                text-align: center;
                & img {
                    width: 35px;
                    height: auto;
                }
            }
            .right {
                float: left;
                width: 85%;
                box-sizing: border-box;
                padding-left: 10px;
                & div{
                    overflow: hidden;
                    & h4 {
                        margin: 0;
                        line-height: 30px;
                        float: left;
                        font-size: 14px;
                    }
                    & h4:hover {
                        color: $--primary-color;
                        text-decoration: underline;
                    }
                    & strong {
                        float: right;
                        font-weight: normal;
                        font-size: 12px;
                        line-height: 30px;
                        color: $--text-color-lighter;
                    }
                }
                & p {
                    margin: 0;
                    text-align: left;
                    font-size: 12px;
                    color: $--text-color-lighter;
                }
            }
        }
    }
    .slide4 {
        position: relative;
        & .main-container {
            margin-top: 60px;
            height: 400px;
            &>img {
                width: 146px;
                height: 42px;
            }
            .partnersList {
                overflow: hidden;
                li {
                    float: left;
                    width: 250px;
                    margin: 20px 0 20px 20px;
                }
            }
        }
    }
    #index {
        .view {
            cursor: pointer;
        }
        .view:hover {
            color: $--text-color;
        }
        .more:hover {
            opacity: .8;
            color: #fff;
        }
        .none {
            margin: 55px 0 70px;
            font-size: 16px;
            line-height: 40px;
            color: $--text-color-lighter;
            border: none;
        }
        .el-carousel__item h3 {
            color: #475669;
            font-size: 14px;
            opacity: 0.75;
            line-height: 150px;
            margin: 0;
        }
        .el-carousel__item {
            background-color: #fff;
        }
        .el-carousel__button{
            background-color: #cb1235;
        }
    }
    .head-top .loginIndex {
        border-bottom: 1px solid #fff;
        p {
            color: #fff;
            .backIndex {
                background: url('../assets/images/masterCenter/topBar/icon_01.png') no-repeat 10px center;
            }
            .helpT {
                background: url('../assets/images/masterCenter/topBar/icon_02.png') no-repeat 10px center;
            }
            .standardT {
                background: url('../assets/images/topBar1/standard.png') no-repeat 10px center / 16px 16px;
            }
            .wechatT {
                background: url('../assets/images/masterCenter/topBar/icon_03.png') no-repeat 10px center;
            }
            .loginOut {
                background: url('../assets/images/masterCenter/topBar/icon_04.png') no-repeat 10px center;
            }
            .line {
                background: #fff;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue